import React from 'react';
import { useTouchOnly, useWindowSize } from '@yme/common/hooks';
import { CardWrapperStyled } from '@yme/components/Header/OfferCards/styled';
import { Card } from './Card';
export function OfferCards({ bigCard, smallCard, closeMenuHandler, labels: { offers_sale_label: label }, }) {
    const { isInfiniteDesktopView } = useWindowSize();
    const isTouchDevice = useTouchOnly();
    if (!bigCard || isTouchDevice) {
        return null;
    }
    return (React.createElement(CardWrapperStyled, { isFullWidth: true },
        React.createElement(Card, { content: bigCard, label: label, closeMenuHandler: closeMenuHandler }),
        smallCard && isInfiniteDesktopView && (React.createElement(Card, { content: smallCard, label: label, closeMenuHandler: closeMenuHandler, isSmall: true }))));
}
OfferCards.displayName = 'OfferCard_AEMComponent';
